import React from 'react';
import { Box, Grid, Typography, Paper, Table, TableCell, TableHead, TableRow, TableBody, IconButton, Select, MenuItem } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import WSSelectField from '../../Components/Select/WSSelect';
import config from '../../Config/clientConfig.json';
import { useForm } from 'react-hook-form';
import { WSIcons } from '../../commonFunctions/iIcons';

export const MainContent: React.FC<{ sidebarOpen: boolean }> = ({ sidebarOpen }) => {  const { register, control } = useForm();

  return (
    <Box
    sx={{
      transition: 'margin-left 0.3s ease',
      marginLeft: sidebarOpen ? '0' : '0', // Adjust margin based on sidebar state
      padding: '16px', // Ensure padding for content
    }}
  >      {/* Header Section */}
      <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{mt:5}}>
        <Grid item>
          <Typography variant="h5" color="black">Summary View</Typography>
        </Grid>
        <Grid item>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
            <WSSelectField
          rules={{ required: true }}
          {...register("willsoar")}
          id="willsoar"
          control={control}
          defaultValue={"0"}
          label=""
          name="willsoar"
          options={config.willsoarConfig.staticOptionData}
        />
            </Grid>
            <Grid item>
              <IconButton>
               <WSIcons.SyncIcon/>
              </IconButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      {/* Main Content Section */}
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {[
          'RECEIPT COUNT', 'VOID RECEIPT', 'OPEN RECEIPT', 'GROSS AMOUNT', 
          'ITEM DISCOUNT', 'RECP DISCOUNT', 'TOTAL TAX', 'TOTAL AMOUNT',
          'AMOUNT PAID','AMOUNT POST', 'BALANCE', 'VOID AMOUNT',
        ].map((label, index) => (
          <Grid item xs={12} sm={8} md={2} key={index}>
            <Paper elevation={1} sx={{ padding: 2, textAlign: 'center', height: '6rem', width: '7rem' }}>
              <Typography variant="h6" color="primary">0.00</Typography>
              <Typography variant="body2">{label}</Typography>
            </Paper>
          </Grid>
        ))}
        
        {/* Additional sections */}
        <Grid item xs={12}>
          <Typography variant="h6" gutterBottom>Hourly Sales</Typography>
          <Paper elevation={1} sx={{ padding: 2, textAlign: 'center', minHeight: '10rem' }} />
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography variant="body1">Top 5 Selling Outlet Items</Typography>
          <Table>
            <TableHead sx={{ backgroundColor: 'white' }}>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Qty.</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </Grid>

        <Grid item xs={12} sm={6}>
          <Typography variant="body1">Settlement Summary</Typography>
          <Table>
            <TableHead sx={{ backgroundColor: 'white' }}>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Count</TableCell>
                <TableCell>Void</TableCell>
                <TableCell>Received</TableCell>
                <TableCell>Total</TableCell>
                <TableCell>User</TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </Grid>

        <Grid item xs={12} sm={3}>
          <Typography variant="body1">Table Information</Typography>
          <Table>
            <TableHead sx={{ backgroundColor: 'white' }}>
              <TableRow>
                <TableCell>Description</TableCell>
                <TableCell>Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Total Tables Served</TableCell>
                <TableCell>0</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Total Pax Count</TableCell>
                <TableCell>0</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Tables Running</TableCell>
                <TableCell>0</TableCell>
              </TableRow>
              <TableRow>
                <TableCell>Tables Reserved</TableCell>
                <TableCell>0</TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Grid>

        {/* Footer Section */}
        <Grid 
          container
          sx={{
            position: 'fixed',
            bottom: 0,
            left: '0.5rem',
            width: '100%',
            backgroundColor: '#f5f5f5',
            textAlign: 'center',
            padding: 1,
          }}
          spacing={2}
          alignItems="center"
          justifyContent="space-between"
        >
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">System Date: 11-11-2024 Monday</Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body2">Software Date: 09-10-2024 Wednesday</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Willsoar</Typography>
          </Grid>
          <Grid item xs={12} sm={2}>
            <Typography variant="body2">Live Support</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
